<template>
  <div v-if="careItemSets.length > 0">
    <ul class="nav nav-tabs" id="careItemTab" role="tablist">
      <li class="nav-item" v-for="(careItemSet) in careItemSets" :key="careItemSet.id">
        <a :class="{ 'nav-link': true, 'active': activeTabId === careItemSet.id }" href="javascript:void(0);"
          @click="activeTabId = careItemSet.id" role="tab">
          <span class="font-14">{{ careItemSet.display_name }}</span>
        </a>
      </li>
    </ul>
    <div class="tab-content tabcontent-border p-10" id="careItemTabContent">
      <div role="tabpanel" v-for="careItemSet in careItemSets" :key="careItemSet.id"
        :class="{ 'tab-pane': true, 'fade': true, 'show': activeTabId === careItemSet.id, 'active': activeTabId === careItemSet.id }"
        :id="'tab-body-' + careItemSet.id">
        <div class="form-group m-b-10" v-for="careItemGroup in careItemSet.care_item_groups" :key="careItemGroup.id">
          <h5 class="font-14">{{ careItemGroup.display_name }}</h5>
          <div class="input-group">
            <div v-for="careItem in careItemGroup.care_items" :key="careItem.id">
              <input :id="'care-item-' + careItem.id" type="checkbox" :value="careItem.id" v-model="selectedValues"
                @change="onChange" />
              <label :for="'care-item-' + careItem.id" class="font-14">{{ careItem.display_name }}</label>
              <span class="p-r-10"></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref, watch, computed, onMounted } from 'vue'
import { useStore } from 'vuex'

const props = defineProps({
  serviceTypeId: Number,
  modelValue: Array
})
const emit = defineEmits(['update:modelValue', 'change'])
const store = useStore()

const careItemSets = ref([])
const selectedValues = ref(props.modelValue || [])
const activeTabId = ref(null)

const getCareItemSets = computed(() => store.getters['session/getCareItemSets'])

const initCareItemSets = () => {
  careItemSets.value = props.serviceTypeId ? getCareItemSets.value(props.serviceTypeId) : []
  if (careItemSets.value.length > 0) {
    activeTabId.value = careItemSets.value[0].id
  }
}

const onChange = (event) => {
  emit('update:modelValue', selectedValues.value)
  emit('change', event)
}

watch(() => props.modelValue, (newValue) => {
  selectedValues.value = newValue || []
})

watch(() => props.serviceTypeId, () => {
  initCareItemSets()
})

onMounted(() => {
  initCareItemSets()
})
</script>

<style scoped></style>
